module.exports = __webpack_public_path__ + "static/media/overlay.18eeeda6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FeaturedArticleSlide/overlay.png
// module id = 167
// module chunks = 0